import type React from 'react';
import { BORDERS, SPACING } from '../../../../constants/design';
import { useColors } from '../../../../contexts/ThemeContext';

interface MenuDirectionPreviewProps {
  direction: 'ltr' | 'rtl';
  size?: number;
}

export const MenuDirectionPreview: React.FC<MenuDirectionPreviewProps> = ({
  direction,
  size = 48,
}) => {
  const tokens = useColors();

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
        padding: SPACING.xs,
        border: `${BORDERS.width.thin} solid ${tokens.border.primary}`,
        borderRadius: BORDERS.radius.sm,
        background: tokens.surface.container,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: SPACING.xs,
        boxSizing: 'border-box',
        flexShrink: 0,
        flexDirection: direction === 'rtl' ? 'row-reverse' : 'row',
      }}
    >
      <div
        style={{
          width: '20%',
          height: '60%',
          background: tokens.primary[100],
          borderRadius: BORDERS.radius.sm,
          border: `${BORDERS.width.thin} solid ${tokens.primary[400]}`,
        }}
      />
      <div
        style={{
          flex: 1,
          height: '60%',
          background: tokens.surface.hover,
          borderRadius: BORDERS.radius.sm,
          border: `${BORDERS.width.thin} solid ${tokens.border.primary}`,
        }}
      />
    </div>
  );
};
